import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LanguageToggle = ({ currentLanguage, onLanguageChange }) => {
  const languages = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'en', label: 'English', flag: '🇬🇧' }
  ];

  return (
    <div className="flex items-center justify-center space-x-2 p-4 bg-muted/30 rounded-lg">
      <Icon name="Globe" size={16} className="text-muted-foreground" />
      <span className="text-sm text-muted-foreground mr-2">
        {currentLanguage === 'fr' ? 'Langue' : 'Language'}:
      </span>
      <div className="flex bg-background border border-border rounded-lg p-1">
        {languages?.map((lang) => (
          <Button
            key={lang?.code}
            variant={currentLanguage === lang?.code ? "default" : "ghost"}
            size="sm"
            onClick={() => onLanguageChange(lang?.code)}
            className="px-3 py-1 text-xs"
          >
            <span className="mr-1">{lang?.flag}</span>
            {lang?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default LanguageToggle;